export const getDataFromClipboard = (clipboardEvent, mimeType = 'text/plain') => {
  if (clipboardEvent.clipboardData && clipboardEvent.clipboardData.getData) {
    return clipboardEvent.clipboardData.getData(mimeType);
  }

  return '';
};
